//值是函数集
export default{
	changeIsMobile(state,data){
		state.isMobile = data
	},
	
	changeNowRouteName(state,data){
		state.nowRouteName = data
	},
	
	changeWindow(state,data){
		state.winW = data.winW
		state.winH = data.winH
	},
	
	changeYearCategory(state,data){
		state.yearCategory = data
	},
	//栏目索引
	changeCategoryIndex(state,data){
		state.categoryIndex = data
	},
	
	changeFriendLink(state,data){
		state.friendLink = data
	},
	
	changeUuid(state,val){
		state.uuid = val
	}
	
}


// WEBPACK FOOTER //
// ./src/store/mutations.js